import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { of } from 'rxjs';

export interface IData {
  title: string;
  model: string
}

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private data: IData = {title: "", model: ""};
  private error: any;
  private contact: any;
  private order: any;

  getData(): Observable<IData> {
    return of(this.data) as Observable<IData>;
  }

  getFirstLoginError(): Observable<any> {
    return of(this.error) as Observable<any>;
  }

  getContact(): Observable<any> {
    return of(this.contact) as Observable<any>;
  }

  getOrder(): Observable<any> {
    return of(this.order) as Observable<any>;
  }
}